<template>
  <v-container class="main-container responsive-height">
    <v-row dense>
      <v-col cols="12" xl="12">
        <v-card
          elevation="0"
          class="all-trade-tab rounded-0 ma-0 px-3 py-5"
          :class="$vuetify.theme.dark ? 'blue-darken-2' : 'transparent'"
        >
          <div
            v-if="this.activeTab === 0"
            style="
              display: flex;
              align-items: flex-end;
              justify-content: flex-end;
            "
          >
            <v-btn
              tile
              small
              elevation="0"
              class="text-capitalize btn-account"
              color="teal-lighten-1"
              @click="downloadExcel"
            >
              <span  style="color: #131C29;"> <v-icon left>mdi-download</v-icon>Excel</span>
            </v-btn>
          </div>
          <v-tabs
            v-model="activeTab"
            :background-color="
              $vuetify.theme.dark ? 'blue-darken-2 ' : 'transparent'
            "
            class="pa-0"
          >
          <v-tab @click="handleTabClick(2)">Commission Rate Sittings</v-tab>
            <v-tab class="ml-0" @click="handleTabClick(0)"
              >Earning Details</v-tab
            >
            <v-tab @click="handleTabClick(1)">Commission Stats</v-tab>
             <v-tab-item>
              <v-sheet
                class="commissionStatusChart pt-5"
                :class="
                  $vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-2'
                "
              >
              <account-types-chips></account-types-chips>
              </v-sheet>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-card
                  :class="
                    $vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-5'
                  "
                >
                  <v-row dense>
                    <v-col cols="12" sm="3" md="3" lg="3">
                      <v-select
                        solo
                        :items="generateLevelsArray"
                        v-model="selectedLevel"
                        append-icon="mdi-chevron-down"
                        label="All Level"
                        class="custom-select"
                        @change="levelFilter"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" lg="3">
                      <v-text-field
                        v-model="search"
                        prepend-icon="mdi-magnify"
                        label="Search anything here ..."
                        single-line
                        solo
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" lg="3">
                      <v-dialog
                        ref="dialog"
                        v-model="modal"
                        :return-value.sync="selectedDates"
                        width="290px"
                        class=""
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="selectedDatesText"
                            prepend-icon="mdi-calendar"
                            append-icon="mdi-chevron-down"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            solo
                            class="custom-select"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="selectedDates"
                          class="custom-date-picker"
                          scrollable
                          range
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            class="error-text-lighten-1"
                            text
                            @click.prevent="cancelSelection"
                          >
                            Cancel
                          </v-btn>
                          <v-btn text @click.prevent="confirmSelection">
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" lg="3">
                      <ul>
                        <li>
                          <span class="text--ash">Total Trade:</span>
                          <span>{{ earningDetails?.totalTrade }}</span>
                        </li>
                        <li>
                          <span class="text--ash">Total Lot:</span>
                          <span>{{ earningDetails?.totalLot }}</span>
                        </li>
                        <li>
                          <span class="text--ash">Commission:</span>
                          <span>{{ earningDetails?.totalCommission }}</span>
                        </li>
                      </ul>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="12" sm="12">
                      <v-card
                        class="pa-0 rounded-0 elevation-0"
                        :class="
                          $vuetify.theme.dark
                            ? 'blue-darken-5'
                            : 'white-lighten-2'
                        "
                      >
                        <v-sheet
                          class="transactionTable ib-commission-table"
                          :class="
                            $vuetify.theme.dark
                              ? 'blue-lighten-1 '
                              : 'white-lighten-1'
                          "
                        >
                          <v-data-table
                            :headers="headers"
                            :items="levelwisecommissionearnings"
                            :search="search"
                            :items-per-page="15"
                            loading-text="Loading... Please wait"
                            :loading="isLoading"
                          >
                            <template v-slot:item.symb="{ item }">
                              <div class="user-profile">
                                <div class="profile-image">
                                  <v-badge
                                    bordered
                                    overlap
                                    small
                                    icon="mdi-star-outline"
                                    size="10"
                                  >
                                    <v-avatar size="32" class="green-darken-2">
                                      <span class="text-small">L1</span>
                                    </v-avatar>
                                  </v-badge>
                                </div>
                              </div>
                            </template>
                            <template v-slot:item.clientName="{ item }">
                              <router-link
                                class="text-capitalize text--green"
                                :to="item.clientLink"
                              >
                                {{ item.clientName }}
                              </router-link>
                            </template>
                            <template v-slot:item.ibName="{ item }">
                              <router-link
                                class="text-capitalize ib-links"
                                :to="item.ibLink"
                              >
                                {{ item.ibName }}
                              </router-link>
                            </template>
                            <template v-slot:item.commission="{ item }">
                              <span
                                class="text-capitalize text-decoration-none text--green"
                              >
                                {{ item.commission }}
                              </span>
                            </template>
                            <template v-slot:item.seaClients="{ item }">
                              <v-btn outlined small>
                                <router-link
                                  class="see-clients-links text-decoration-none text-capitalize"
                                  :to="item.seaClientsLinks"
                                >
                                  See Clients:
                                  <span>{{ item.seaClientsNumber }}</span>
                                </router-link>
                              </v-btn>
                            </template>
                          </v-data-table>
                        </v-sheet>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-sheet
                class="apexChartWrapper commissionStatusChart"
                :class="
                  $vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-2'
                "
              >
                <CurrencyChart  :stats="stats"></CurrencyChart>
                <LevelWiseChart :stats="stats"></LevelWiseChart>
                <AccountTypeChart :stats="stats"></AccountTypeChart>
              </v-sheet>
            </v-tab-item>
          </v-tabs>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AccountTypeChart from "@/components/Commission/AccountTypeChart.vue";
import AccountTypesChips from '@/components/Commission/AccountTypesChips.vue';
import CurrencyChart from "@/components/Commission/CurrencyChart.vue";
import LevelWiseChart from "@/components/Commission/LevelWiseChart.vue";
import {
  ALLACCOUNTSSUMMARY__ACTIONS,
  COMMISSIONSTATS__ACTIONS,
} from "@/store/action-types";
import { mapActions, mapState } from "vuex";
import * as XLSX from "xlsx";


export default {
  components: {
    CurrencyChart,
    LevelWiseChart,
    AccountTypeChart,
    AccountTypesChips,
  },
  data() {
    return {
      headers: [
        {
          text: "Level",
          align: "center",
          value: "level",
        },
        { text: "Name", value: "name", align: "center" },
        { text: "IB Code", value: "ib_code", align: "center" },
        { text: "Account No.", value: "account_no", align: "center" },
        { text: "Acc. Type", value: "acc_type", align: "center" },
        { text: "Time", value: "time", align: "center" },
        { text: "Position", value: "position", align: "center" },
        { text: "Symbol", value: "symbol", align: "center" },
        { text: "Lot", value: "lot", align: "center" },
        { text: "Commission($)", value: "commission", align: "center" },
      ],
      search: "",
      selectedLevel: null,
      selectedDates: [],
      selectedDatesText: null,
      modal: false,
      activeTab: 0,
    };
  },
  computed: {
    ...mapState("accountsummary", ["accountsummary"]),
    ...mapState("commissionstates", [
      "levelwisecommissionearnings",
      "earningDetails",
      "isLoading",
      "stats"
    ]),

    generateLevelsArray() {
      const levelsArray = [];
      if (this.accountsummary && this.accountsummary.businessLevel) {
        for (let i = 0; i < this.accountsummary.businessLevel; i++) {
          levelsArray.push(`Level ${i + 1}`);
        }
      }
      return ["All Level", ...levelsArray];
    },
  },

  methods: {
    ...mapActions("accountsummary", [
      ALLACCOUNTSSUMMARY__ACTIONS.ALLACCOUNTSSUMMARY,
    ]),

    ...mapActions("commissionstates", [
      COMMISSIONSTATS__ACTIONS.LEVELWISECOMMISSIONEARNING,
      COMMISSIONSTATS__ACTIONS.COMMISSIONSTATS
    ]),

    handleTabClick(index) {
      this.activeTab = index;
    },

    getCurrentDate(dayOffset = 0) {
      const date = new Date();
      date.setDate(date.getDate() + dayOffset);
      const formattedDate = date.toISOString().split("T")[0];
      return formattedDate;
    },

    cancelSelection() {
      this.modal = false;
    },

    confirmSelection() {
      let startDate = new Date(this.selectedDates[0]);
      let endDate = new Date(this.selectedDates[1]);

      if (startDate > endDate) {
        [startDate, endDate] = [endDate, startDate];
      }

      const parameter = {
        date: `${startDate.toISOString().split("T")[0]}to${
          endDate.toISOString().split("T")[0]
        }`,
      };

      this.modal = false;
      this[COMMISSIONSTATS__ACTIONS.LEVELWISECOMMISSIONEARNING](parameter);

      this.selectedDates = [startDate, endDate];
      this.selectedDatesText = this.selectedDates
        .map((date) => date.toISOString().split("T")[0])
        .join(" ~ ");
    },

    async levelFilter() {
      const parameter = {
        level:
          this.selectedLevel === "All Level"
            ? "all"
            : Number(this.selectedLevel?.replace(/\D/g, "")),
      };

      this[COMMISSIONSTATS__ACTIONS.LEVELWISECOMMISSIONEARNING](parameter);
    },

    downloadExcel() {
      const wb = XLSX.utils.book_new();
      const commissionData = this.levelwisecommissionearnings;
      const earningDetails = this.earningDetails;

      // Rename keys in commission data objects
      const modifiedCommissionData = commissionData.map((item) => ({
        LEVEL: item.level,
        "ACC NAME": item.name,
        "CHILD IB": item.ib_code,
        "ACC NO": item.account_no,
        "ACC TYPE": item.acc_type,
        TIME: item.time,
        POSITION: item.position,
        SYMBOL: item.symbol,
        LOT: item.lot,
        COMMISSION: item.commission,
      }));

      // Create worksheet for commission data
      const ws = XLSX.utils.json_to_sheet(modifiedCommissionData);

      // Generate Excel file and trigger download
      XLSX.utils.book_append_sheet(wb, ws, "Commission Data");

      // Add total lot, commission, and total commission in the same row
      const totalRow = modifiedCommissionData.length + 2;

      // Add total lot
      ws[`H${totalRow}`] = {
        t: "s",
        v: `Total`,
        s: { font: { bold: true } },
      };

      // Add total lot
      ws[`I${totalRow}`] = {
        t: "s",
        v: `${parseFloat(earningDetails.totalLot)}`,
        s: { font: { bold: true } },
      };

      // Add total commission
      ws[`J${totalRow}`] = {
        t: "s",
        v: `${parseFloat(earningDetails.totalCommission)}`,
        s: { font: { bold: true } },
      };

      // Adjust sheet range
      ws["!ref"] = XLSX.utils.encode_range({
        s: { c: 0, r: 0 },
        e: { c: 9, r: totalRow },
      });

      XLSX.writeFile(wb, "commission_data.xlsx");
    },
  },

  async mounted() {
    await this[ALLACCOUNTSSUMMARY__ACTIONS.ALLACCOUNTSSUMMARY]();
    await this[COMMISSIONSTATS__ACTIONS.LEVELWISECOMMISSIONEARNING]();
    await this[COMMISSIONSTATS__ACTIONS.COMMISSIONSTATS]();
    this.selectedDatesText = [
      this.getCurrentDate(-7),
      this.getCurrentDate(),
    ].join(" ~ ");
  },
};
</script>
